module.exports = [{
      plugin: require('/zeit/58d46a72/node_modules/gatsby-plugin-preact/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
